import { Controller } from 'stimulus';
import Cookies from 'js-cookie';

export default class LanguageSwitcherController extends Controller {
  static targets = ['source'];

  handleLangSwitch = (event) => {
    event.preventDefault();
    this.requestLocaleDomainCookie(event);
  }

  requestLocaleDomainCookie = (event) => {
    const intentionalLocales = Cookies.getJSON('intentional_locale_switch');
    const { locale } = event.target.dataset;
    const cookieDomainArray = window.location.hostname.split('.');
    const cookieDomain = `${cookieDomainArray[1]}.${cookieDomainArray[2]}`;
    let updatedIntentionalLocales;

    if (!intentionalLocales) {
      updatedIntentionalLocales = [locale];
      Cookies.set('intentional_locale_switch', updatedIntentionalLocales, { domain: cookieDomain });
    } else if (!intentionalLocales.includes(locale)) {
      updatedIntentionalLocales = intentionalLocales;
      updatedIntentionalLocales.push(locale);
      Cookies.set('intentional_locale_switch', updatedIntentionalLocales, { domain: cookieDomain });
    }

    window.location = event.target.href;
  }

  toggle(event) {
    event.preventDefault();

    this.sourceTarget.classList.toggle('is-visible');
    this.element.classList.toggle('menu-visible');
  }
}
